import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';

export default function ContactForm() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState(''); // 'success', 'error', or ''
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    try {
      await emailjs.send(
        'service_jx4nftp',
        'template_z4cvbhc',
        {
          name: formData.name,
          email: formData.email,
          title: formData.subject,
          message: formData.message,
        },
        'eq2yXAFZnWZVZvPRi'
      );

      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Email send error:', error);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30"
    >
      <div className="row">
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">
            {t('contact.nameLabel')} <span style={{color: 'red'}}>*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="cs_form_field"
            placeholder={t('contact.namePlaceholder')}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">
            {t('contact.emailLabel')} <span style={{color: 'red'}}>*</span>
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="cs_form_field"
            placeholder={t('contact.emailPlaceholder')}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color">
            {t('contact.subjectLabel')} <span style={{color: 'red'}}>*</span>
          </label>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            className="cs_form_field"
            placeholder={t('contact.subjectPlaceholder')}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color">
            {t('contact.messageLabel')} <span style={{color: 'red'}}>*</span>
          </label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            cols={30}
            rows={10}
            className="cs_form_field"
            placeholder={t('contact.messagePlaceholder')}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          {status === 'success' && (
            <div className="alert alert-success" role="alert">
              {t('contact.successMessage')}
            </div>
          )}
          {status === 'error' && (
            <div className="alert alert-danger" role="alert">
              {t('contact.errorMessage')}
            </div>
          )}
          <div className="cs_height_18" />
          <button
            type="submit"
            className="cs_btn cs_style_1"
            disabled={isSubmitting}
          >
            <span>
              {isSubmitting ? t('contact.sending') : t('contact.submit')}
            </span>
            <i>
              <img src="/images/icons/arrow_white.svg" alt="Icon" />
              <img src="/images/icons/arrow_white.svg" alt="Icon" />
            </i>
          </button>
        </div>
      </div>
    </form>
  );
}
